export const CONTEXT_PANEL_WIDTH = 280;
